export const getRouteSearchStr = (queryObj: { sort: string }): string => `?${new URLSearchParams(queryObj).toString()}`;
